module.exports = __webpack_public_path__ + "static/media/sidebar-toggler-dark.7eed6140.svg";